module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"img.1.alt":"dføur","h2.2":"Beispiele","networkerror":"Die Gemeindesuche ist zur Zeit nicht verfügbar."},"fr":{"img.1.alt":"Le dføur","h2.2":"Examples","networkerror":"La recherche de communauté n\u0027est pas disponible actuellement."},"en":{"img.1.alt":"dføur","h2.2":"Examples","networkerror":"The municipality search is not available at the moment."}}')
  delete Component.options._Ctor
}
